<template>
  <div :id="filtro.filtro" class="container-valor-range d-flex align-items-center position-relative">
    <div class="toogle-range d-flex align-items-center text-nowrap font-weight-500 p-2 gap-1 border-radius-8" :style="estiloFoco" @click="alternarPainel">
      <b class="flex-shrink-0 font-weight-500">{{ filtro.name }}:</b>
      <span v-if="!temSelecao" class="selecione text-gray-500 font-weight-400">{{ $i18n('interface.novo_filtro.selecione') }}</span>
      <span v-else class="resumo-selecao text-truncate" :title="resumoSelecao">{{ resumoSelecao }}</span>
      <SVGIcon v-if="!filtro.default" class="flex-shrink-0" iconName="icon-close" :size="8" @click.stop="onExcluded" />
    </div>
    <div
      v-if="painelAtivo"
      class="select-adicionar-campos painel-range"
      :class="{ 'abre-para-cima': abrirParaCima, 'abre-esquerda': abrirParaEsquerda }"
    >
      <div class="container-campos-range d-flex gap-3 px-3 pt-3">
        <label class="campo-range d-flex flex-column gap-1">
          <span class="rotulo font-weight-500">{{ rotuloMinimo }}</span>
          <input
            ref="inputDe"
            type="text"
            class="input-range font-size-14 p-2"
            inputmode="decimal"
            :placeholder="placeholder"
            v-model="valorDe"
            @keyup.enter="aplicar"
          />
        </label>
        <label class="campo-range d-flex flex-column gap-1">
          <span class="rotulo font-weight-500">{{ rotuloMaximo }}</span>
          <input
            type="text"
            class="input-range font-size-14 p-2"
            inputmode="decimal"
            :placeholder="placeholder"
            v-model="valorAte"
            @keyup.enter="aplicar"
          />
        </label>
      </div>
      <div class="container-button-aplicar">
        <button type="button" class="btn btn-maino" @click="aplicar">{{ $i18n('interface.novo_filtro.aplicar') }}</button>
      </div>
    </div>
  </div>
</template>
<script>
import SVGIcon from '../../../SvgIcon.vue';

const SUFIXO_DE = '_de';
const SUFIXO_ATE = '_ate';
const EVENTO_ABRIR_SELECT = 'filtro:select:abrir';

export default {
  props: {
    filtro: {
      type: Object,
      required: true
    },
    path: {
      type: String,
      required: true
    }
  },
  components: {
    SVGIcon
  },
  data() {
    return {
      valorDe: '',
      valorAte: '',
      painelAtivo: false,
      abrirParaCima: false,
      abrirParaEsquerda: false,
      unsubscribe: null,
    };
  },
  computed: {
    paramDe() {
      return `${this.filtro.filtro}${SUFIXO_DE}`;
    },
    paramAte() {
      return `${this.filtro.filtro}${SUFIXO_ATE}`;
    },
    rotuloMinimo() {
      return this.filtro.parametros?.minimo || this.$i18n('interface.novo_filtro.valor_minimo');
    },
    rotuloMaximo() {
      return this.filtro.parametros?.maximo || this.$i18n('interface.novo_filtro.valor_maximo');
    },
    placeholder() {
      return this.filtro.parametros?.placeholder || this.$i18n('interface.novo_filtro.digite');
    },
    separador() {
      return this.filtro.parametros?.separador || '~';
    },
    temSelecao() {
      return Boolean((this.valorDe || '').trim() || (this.valorAte || '').trim());
    },
    resumoSelecao() {
      const de = (this.valorDe || '').trim();
      const ate = (this.valorAte || '').trim();
      if (de && ate) return `${de} ${this.separador} ${ate}`;
      if (de) return `${this.rotuloMinimo}: ${de}`;
      if (ate) return `${this.rotuloMaximo}: ${ate}`;
      return '';
    },
    estiloFoco() {
      if (!this.painelAtivo) return;
      return 'border-color: var(--maino-blue-hover); color: var(--maino-blue-hover);';
    },
  },
  methods: {
    alternarPainel() {
      this.painelAtivo = !this.painelAtivo;

      if (this.painelAtivo) {
        document.dispatchEvent(new CustomEvent(EVENTO_ABRIR_SELECT, { detail: { id: this.filtro.filtro } }));
        this.$nextTick(() => {
          this.ajustaDirecaoAbertura();
          this.$refs.inputDe?.focus();
        });
      } else {
        this.fechaPainel();
      }
    },
    ajustaDirecaoAbertura() {
      const container = document.getElementById(this.filtro.filtro);
      const dropdown = container?.querySelector('.painel-range');
      if (!container || !dropdown) return;

      const retanguloContainer = container.getBoundingClientRect();
      const retanguloDropdown = dropdown.getBoundingClientRect();

      this.abrirParaCima = retanguloContainer.bottom + retanguloDropdown.height > window.innerHeight
        && retanguloContainer.top - retanguloDropdown.height > 0;
      this.abrirParaEsquerda = retanguloContainer.left + retanguloDropdown.width > window.innerWidth;
    },
    aplicar() {
      this.aplicarParam(this.paramDe, (this.valorDe || '').trim());
      this.aplicarParam(this.paramAte, (this.valorAte || '').trim());
      this.painelAtivo = false;
      this.fechaPainel();
    },
    aplicarParam(nome, valor) {
      if (valor === '') {
        this.$removeFiltroDaURL(nome, this.path);
        this.$store.commit('removeFiltroAplicado', nome);
        return;
      }
      this.$aplicaFiltroEmURL(nome, valor, this.path);
      this.$store.commit('addFiltroAplicado', { filtro: nome, valor });
    },
    aoRemoverFiltroSlot() {
      this.$removeFiltroDaURL(this.paramDe, this.path);
      this.$removeFiltroDaURL(this.paramAte, this.path);
      this.$store.commit('removeFiltroAplicado', this.paramDe);
      this.$store.commit('removeFiltroAplicado', this.paramAte);
    },
    onExcluded() {
      this.$store.commit('removeFiltro', this.filtro.filtro);
      this.aoRemoverFiltroSlot();
      this.$filtroDb.removeFiltro(this.path, this.filtro.filtro)
        .catch(error => exibe_erro('Erro ao remover preferencia de filtro'));
    },
    fechaPainel() {
      const aplicados = this.$store.state.filtroAplicados;
      this.valorDe = aplicados[this.paramDe] || '';
      this.valorAte = aplicados[this.paramAte] || '';
      this.abrirParaCima = false;
      this.abrirParaEsquerda = false;
    },
  },
  mounted() {
    const aplicados = this.$store.state.filtroAplicados;
    this.valorDe = aplicados[this.paramDe] || '';
    this.valorAte = aplicados[this.paramAte] || '';

    this.unsubscribe = this.$store.subscribe((mutation) => {
      if (mutation.type === 'removeFiltro' && mutation.payload === this.filtro.filtro) {
        this.aoRemoverFiltroSlot();
      }
    });

    this.fecharAoClicarFora = (event) => {
      if (!event.target.closest('.container-valor-range')) {
        this.painelAtivo = false;
        this.fechaPainel();
      }
    };
    this.fecharAoAbrirOutro = (event) => {
      if (event.detail.id !== this.filtro.filtro && this.painelAtivo) {
        this.painelAtivo = false;
        this.fechaPainel();
      }
    };
    document.addEventListener('click', this.fecharAoClicarFora);
    document.addEventListener(EVENTO_ABRIR_SELECT, this.fecharAoAbrirOutro);
  },
  beforeUnmount() {
    if (this.unsubscribe) this.unsubscribe();
    document.removeEventListener('click', this.fecharAoClicarFora);
    document.removeEventListener(EVENTO_ABRIR_SELECT, this.fecharAoAbrirOutro);
  },
}
</script>
